import { Box, styled } from '@withjoy/joykit';

export const SliderContainer = styled(Box)<{ aspectRatio?: number }>`
  .slick-slider {
    width: 100%;
    height: 100%;
    ${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
  }

  /*
   * Pin fade-mode geometry so react-slick's mount-time inline styles are a visual no-op.
   *
   * react-slick assigns .slick-track / .slick-slide geometry in JS after mount, so first-paint
   * geometry differs from settled geometry and Chromium scores a shift even though nothing
   * visibly moves: measured CLS 0.30 on mobile photoTrio (which swaps to this slider below xs),
   * 0.60 on desktop photoSlider and 0.42 on aloha photoSlider. PRNT-4799.
   *
   * Both axes have to be pinned. Horizontally the pre-init track is width:700% / left:-100% with
   * per-slide percentage offsets; on init, fade mode DROPS the track's left entirely (getTrackCSS
   * returns only opacity + width), sliding the whole track one list-width right. Pinning left
   * alone just moves the jump to the slides, and shrinking the track without taking slides out of
   * flow wraps them into N rows — so track and slides are pinned together, slides absolutely
   * positioned. That also subsumes hiding the non-first slides pre-init.
   *
   * Every slider here is fade mode (SLIDER_BASE_SETTINGS.fade), where slides are overlaid and
   * cross-faded via per-slide opacity rather than translating the track — so the track's own
   * geometry is never used for motion and none of this affects the transition.
   *
   * Sizing: with an aspectRatio (Brannan) the list owns the box; without one (Aloha) the 100vh
   * ancestor does, so everything is height:100%.
   */
  .slick-list {
    overflow: hidden;
    ${({ aspectRatio }) => (aspectRatio ? `aspect-ratio: ${aspectRatio}; height: auto !important;` : 'height: 100%;')}
  }
  .slick-track {
    width: 100% !important;
    left: 0 !important;
    height: 100%;
  }
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }
  .slick-slide {
    position: absolute !important;
    top: 0;
    left: 0 !important;
    width: 100% !important;
  }

  .slick-dots {
    bottom: 30px;
    pointer-events: auto;
  }
  .slick-dots li {
    width: auto;
    height: auto;
    margin: 0 6px;
  }
  .slick-dots .slick-active .custom-dot {
    background-color: ${({ theme }) => theme.colors.accentBlue2};
  }

  .slick-prev,
  .slick-next {
    display: none !important;
  }
`;
